// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpacePanelGroups__list-dac235 {
  flex-grow: 1;
  box-sizing: border-box;
  overflow-y: auto;
}

.SpacePanelGroups__empty-bddb19 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SpacePanel/SpacePanelGroups/SpacePanelGroups.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".list {\n  flex-grow: 1;\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.empty {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `SpacePanelGroups__list-dac235`,
	"empty": `SpacePanelGroups__empty-bddb19`
};
module.exports = ___CSS_LOADER_EXPORT___;
